<template>
  <div class="fr_container">
    <div class="fr-content buttons">
      <div class="fr-column">
        <a class="button-text" :class="{'isIE': this.isIE}" title target="_blank" :href="'mailto:?body=https://www.empr.com/custom/patient-journeys/odactra/'">
          <img class="b-image" alt src="@/assets/img/patients/susan/send.svg"/><span class="b-text">Click to send this case to a colleague</span></a>
      </div>
      <div class="fr-column">
        <a class="button-text" :class="{'isIE': this.isIE}" title :href="this.urls.HCP_INFO" target="_blank"><img class="b-image" alt src="@/assets/img/patients/susan/request.svg"/><span class="b-text">Request a rep</span></a>
      </div>
      <div class="fr-column">
        <a class="button-text" :class="{'isIE': this.isIE}" title :href="this.urls.HCP" target="_blank"><img class="b-image" alt src="@/assets/img/patients/susan/learn.svg"/><span class="b-text">Learn more about ODACTRA<sup>®</sup></span></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FooterButtons',
  computed: {
    ...mapState(['userAgent', 'urls']),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
  },
};
</script>
